import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="bg-secondary text-secondary-foreground py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-gradient-cta flex items-center justify-center">
                <span className="text-white font-bold text-xs">QCO</span>
              </div>
              <span className="font-display font-bold text-lg">QuantoCustaObra</span>
            </div>
            <p className="text-secondary-foreground/70 text-sm leading-relaxed max-w-md mb-4">
              Plataforma de orçamentação de obras com Inteligência Artificial.
              Baseada no SINAPI e CUB oficiais para máxima confiabilidade.
            </p>
            <p className="text-secondary-foreground/50 text-sm">
              ✓ +10.000 orçamentos gerados no Brasil
            </p>
          </div>

          <div>
            <h4 className="font-display font-bold mb-4">Plataforma</h4>
            <ul className="space-y-2 text-sm text-secondary-foreground/70">
              <li>
                <Link to="/orcamento/novo" className="hover:text-primary transition-colors no-underline">
                  Calcular Obra
                </Link>
              </li>
              <li>
                <Link to="/orcamento-cub" className="hover:text-primary transition-colors no-underline">
                  Orçamento CUB
                </Link>
              </li>
              <li>
                <Link to="/planos" className="hover:text-primary transition-colors no-underline">
                  Planos
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-primary transition-colors no-underline">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold mb-4">Institucional</h4>
            <ul className="space-y-2 text-sm text-secondary-foreground/70">
              <li>
                <Link to="/termos-de-uso" className="hover:text-primary transition-colors no-underline">
                  Termos de Uso
                </Link>
              </li>
              <li>
                <Link to="/politica-de-reembolso" className="hover:text-primary transition-colors no-underline">
                  Política de Reembolso
                </Link>
              </li>
              <li><span>Privacidade</span></li>
              <li><span>Contato</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-foreground/10 pt-8 text-center text-sm text-secondary-foreground/50">
          © {new Date().getFullYear()} QuantoCustaObra. Todos os direitos reservados.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
